import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateLocale'
})
export class DateLocalePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) { }

  transform(value?: string | number | Date, format?: string): string | undefined {
    if (value === undefined || value === '' || value as number < 0) {
      return undefined;
    }

    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang ?? 'fr');
    return datePipe.transform(value, format, 'UTC', this.translateService.currentLang) ?? undefined;
  }
}
